import { indexData } from '@/mocks/home';

const iconColors = ['bg-primary-50 text-primary-600', 'bg-accent-50 text-accent-600', 'bg-secondary-50 text-secondary-600', 'bg-primary-50 text-primary-600', 'bg-accent-50 text-accent-600', 'bg-secondary-50 text-secondary-600', 'bg-primary-50 text-primary-600'];

export default function IndexSection() {
  return (
    <section id="index" className="w-full px-4 md:px-6 lg:px-10 py-10 md:py-14">
      <div className="w-full">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-7 rounded-full bg-secondary-500" />
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">内容索引</h2>
          </div>
          <span className="text-xs text-foreground-500 hidden sm:block">共7个分类入口 · 快速定位</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {indexData.map((item, index) => (
            <div
              key={index}
              className="group rounded-xl border border-background-200/70 bg-background-50 p-4 md:p-5 text-center hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 mx-auto rounded-xl ${iconColors[index]} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${item.icon} text-lg`} />
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1.5">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-1">{item.count}</p>
              <p className="text-[11px] text-foreground-400 hidden sm:block">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}